import axios, { AxiosInstance } from 'axios'
import { LOCALSTORAGE_TOKEN_KEY } from '@/constants'

class ApiClientClass {
  axios: AxiosInstance = axios
  private authInterceptorId: number

  constructor(private config: any = {}) {
    this.configureInstance(config)
  }

  configureInstance(config: any = this.config) {
    const configOptions = {
      timeout: 5000,
    }

    this.axios = axios.create(configOptions)

    if (process.env && process.env.VUE_APP_MYTIME_BASE_URL) {
      // console.log('setting client base url', process.env.VUE_APP_MYTIME_BASE_URL)
      this.axios.defaults.baseURL = process.env.VUE_APP_MYTIME_BASE_URL
    }
  }

  authenticate(token: string) {
    localStorage.setItem(LOCALSTORAGE_TOKEN_KEY, token)
    this.authInterceptorId = this.axios.interceptors.request.use((config) => {
      if (!config.params) { config.params = {} }
      config.params.auth_token = token
      return config
    })
  }

  get get() { return this.axios.get }
  get post() { return this.axios.post }
  get put() { return this.axios.put }
  get delete() { return this.axios.delete }
  get head() { return this.axios.head }
  get patch() { return this.axios.patch }
  get request() { return this.axios.request }
  get defaults() { return this.axios.defaults }
  get interceptors() { return this.axios.interceptors }
}

export const ApiClient = new ApiClientClass()
